import React from 'react'
import { useIntl } from 'react-intl'

import { FooterButton, PropertyInfo, PropertyTitle } from './styles'
import Button from 'src/comps/Atom/Buttons/Button'
import Stars from 'client/components/Stars'

interface ZoomCTAProps {
  name: string
  stars: number
  onClick: () => void
}

export const ZoomCTA = ({ name, stars, onClick }: ZoomCTAProps) => {
  const intl = useIntl()

  return (
    <FooterButton>
      <PropertyInfo>
        <PropertyTitle size="m">{name}</PropertyTitle>
        <Stars stars={stars} size={15} />
      </PropertyInfo>
      <Button
        backgroundColor="brand1"
        borderColor="brand1"
        size="m"
        type="button"
        onClick={onClick}
      >
        {intl.formatMessage({ id: 'global.availability-check' })}
      </Button>
    </FooterButton>
  )
}
